import { useEffect, useState } from 'react';
import { apiRequest } from './apiClient';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Step 45 — lightweight hook used by `App.js` to decide whether to show
 * the sidebar "Onboarding" entry. Uses the same /api/auth/setup-checklist
 * endpoint so the state is consistent with the banner.
 * Returns `null` while loading, `true` or `false` once resolved.
 */
export function useSetupAllClear(refreshKey = 0) {
  const [allClear, setAllClear] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { ok, data } = await apiRequest('GET', `${BACKEND_URL}/api/auth/setup-checklist`);
        if (!cancelled) setAllClear(ok ? !!data.all_clear : null);
      } catch {
        if (!cancelled) setAllClear(null);
      }
    })();
    return () => { cancelled = true; };
  }, [refreshKey]);
  return allClear;
}
